import { render, staticRenderFns } from "./LearnExamReportViewer.vue?vue&type=template&id=a35bec58&scoped=true"
import script from "./LearnExamReportViewer.vue?vue&type=script&lang=js"
export * from "./LearnExamReportViewer.vue?vue&type=script&lang=js"
import style0 from "./LearnExamReportViewer.vue?vue&type=style&index=0&id=a35bec58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35bec58",
  null
  
)

export default component.exports